import { Component, OnInit } from '@angular/core';
import { SELECTED_ACTIVE_CUSTOMERS_EULA_CONFIGS } from '@app-core/constants/constants';
import { EULA_CONFIG } from '@app-core/models/core.model';
import { AccessService } from '@app-core/services/access/access.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-eula-document',
  templateUrl: './eula-document.component.html',
  styleUrls: ['./eula-document.component.scss'],
})
export class EulaDocumentComponent implements OnInit {
  public template: EULA_CONFIG['template'];

  constructor(private accessService: AccessService) {}

  ngOnInit(): void {
    this.decideWhichTemplateToShow();
  }

  private decideWhichTemplateToShow(): void {
    if (environment.isGeotabEnv) this.template = 'general';
    const customerName = this.accessService.getLoginInfo().customerName;
    this.template = SELECTED_ACTIVE_CUSTOMERS_EULA_CONFIGS[customerName].template;
  }
}
